<template>
    <div>
        <ui-modal  
            ref="editModal" 
            class="invoice-refund-modal"
            :title="'refund' === cancellationType ? 'Refund' : 'Void'"  
            @hide="hidden"
            dismiss-on="close-button esc"
        >
            <div v-if="invoice">
                <ui-select
                    v-model="cancellationReason"
                    label="Why are you cancelling the transaction?"
                    placeholder="Please select reason..."
                    :options="reasons"
                    :disabled="isBusy"
                />

                <ui-textbox
                    v-if="invoice.cancellation_reason"
                    v-model="invoice.cancellation_description"
                    label="Can you give any more detail as to why the transaction failed?"
                    help="Optional"
                    enforce-maxlength
                    :multi-line="true"
                    :maxlength="256"
                    :disabled="isBusy"
                />

                <div 
                    slot="footer" 
                    style="width: 100%; text-align: right;"
                >
                    <ui-button 
                        :disabled="isBusy"
                        @click="close"
                    >
                        Cancel
                    </ui-button>
                    <ui-button 
                        :loading="isBusy"
                        color="red" 
                        @click="done"
                    >
                        {{ 'refund' === cancellationType ? 'Refund' : 'Void' }}
                    </ui-button>
                </div>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import Filters from '../../filters'
    import { InvoiceHelper, InvoiceResource, InvoiceCancellationReasons } from '../../classes/Api/Invoice'
    import {PaymentMethodKeyValueList, PaymentTypes} from '../../classes/Api/Payment'

    export default {
        filters: Filters,
        data() {
            return {
                invoice: null,
                isBusy: false,
            }
        },
        computed: {
            cancellationType() {
                let paymentsTotal = _.sumBy(this.paymentsMade, 'amount')

                return (paymentsTotal > 0) ? 'refund' : 'void'
            },
            invoiceTotal() {
                return this.invoice ? (new InvoiceHelper(this.invoice).total()) : 0
            },
            cancellationReason: {
                get() {
                    if (this.invoice.cancellation_reason) {
                        return this.reasons.find(
                            item => this.invoice.cancellation_reason === item.value
                        )
                    }
                    return ''
                },
                set(option) {
                    this.invoice.cancellation_reason = option.value
                }
            },
            paymentsMade() {
                return this.payments.filter(item => {
                    return item.is_posted && item.type !== PaymentTypes.PART_EXCHANGE
                })
            },
            reasons() {
                return InvoiceCancellationReasons
            },
            payments: {
                get() {
                    return this.invoice ? this.invoice.payments : []
                },
                set(value) {
                    if (this.invoice) {
                        this.invoice.payments = value
                    }
                }
            },
        },
        methods: {
            getPaymentMethodLabel(method) {
                return PaymentMethodKeyValueList.find(item => method === item.value).label
            },
            open(invoice) {
                this.invoice = _.cloneDeep(invoice)

                this.$refs.editModal.open();
            },
            done() {
                this.isBusy = true

                let id = this.invoice.id,
                    reason = this.invoice.cancellation_reason,
                    description = this.invoice.cancellation_description

                if ('refund' === this.cancellationType) {
                    InvoiceResource.refund(id, reason, description).then(response => {
                        this.$emit('updated', response.data);
                        this.isBusy = false
                        this.close()
                    }, error => { this.isBusy = false; handleApiError(error) })
                } else {
                    InvoiceResource.void(id, reason, description).then(response => {
                        this.$emit('updated', response.data);
                        this.isBusy = false
                        this.close()
                    }, error => { this.isBusy = false; handleApiError(error) })
                }
            },
            close() {
                this.$refs.editModal.close()
            },
            hidden() {
                this.invoice = null
            }
        }
    }
</script>